import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_2 = {
  key: 1,
  class: "app-info-container"
}
const _hoisted_3 = { class: "app-info-row header-row" }
const _hoisted_4 = { class: "col-nom" }
const _hoisted_5 = { class: "col-version" }
const _hoisted_6 = { class: "col-env" }
const _hoisted_7 = { class: "app-info-row" }
const _hoisted_8 = { class: "col-nom" }
const _hoisted_9 = { class: "col-version" }
const _hoisted_10 = { class: "col-env" }
const _hoisted_11 = { class: "col-nom" }
const _hoisted_12 = { class: "col-version" }
const _hoisted_13 = { class: "col-env" }
const _hoisted_14 = { class: "col-nom" }
const _hoisted_15 = { class: "col-env" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ModalCard, {
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel'))),
        headerTitle: _ctx.$t('modale.app.info.title'),
        withoutBotNav: true,
        "active-validate": false
      }, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_LoaderComponent)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('modale.app.info.colonne.nom')), 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('modale.app.info.colonne.version')), 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('modale.app.info.colonne.environnement')), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.frontInfo.nom), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.frontInfo.version), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.frontInfo.environnement), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appInfo, (info, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: "app-info-row"
                  }, [
                    info
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(info.nom), 1),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(info.version), 1),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(info.environnement?.toUpperCase() ?? '-'), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(key), 1),
                          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "col-version" }, "-", -1)),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('modale.app.info.indisponible') ?? 'Indisponible'), 1)
                        ], 64))
                  ]))
                }), 128))
              ]))
        ]),
        _: 1
      }, 8, ["headerTitle"])
    ]),
    _: 1
  }))
}